import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { useAppStore } from "@hooks/useAppStore";
import { useGlobalStore } from "@hooks/useGlobalStore";

export const useCanBypassPaywall = () => {
	const { isAdmin } = useAuthContext();
	const isPaywallEnabled = useAppStore(
		(store) => store.app.purchase?.isPaywallEnabled ?? true,
	);
	const adminPaywallEnabled = useGlobalStore(
		(state) => state.adminPaywallEnabled,
	);
	return isAdmin ? !adminPaywallEnabled : !isPaywallEnabled;
};
